<mat-toolbar>
  <ng-container *ngTemplateOutlet="headerContent"></ng-container>
  <span class="flex-auto"></span>
  <div class="flex">
    @if (showDebugTrace) {
      <lib-trace-badge />
    }
    <div class="h-[58px]">
      <lib-lookup-field [field]="languageSelectionField"></lib-lookup-field>
    </div>
    <button mat-icon-button (click)="toggleTheme()" i18n-aria-label aria-label="toggle theme button" role="button">
      <lib-app-icon id="change-theme-icon" [icon]="getIconName()" [size]="'20x14'" />
    </button>
    <button mat-icon-button i18n-aria-label aria-label="notification button" role="button">
      <lib-app-icon [icon]="'notification_icon'" [size]="'20x14'" />
    </button>
    <button mat-icon-button (click)="toggleDrawer()" class="!p-0 !pt-[4px]">
      <img [ngSrc]="profilePicturePath()" class="profile-picture" width="40" height="40" priority i18n-alt
        alt="user profile picture" tabindex="0" />
    </button>
  </div>
</mat-toolbar>

<lib-settings-drawer [profilePicturePath]="profilePicturePath()" class="fixed top-0 bottom-0 right-0 !z-[15]" />